export const messages = {
  page: {
    header: {
      id: 'appointmentsCard.Page.Header',
      defaultMessage: 'Appointments',
    },
    requestNew: {
      id: 'appointmentsCard.Page.RequestNew',
      defaultMessage: 'Request a New Appointment',
    },
    viewMore: {
      id: 'appointmentsCard.Page.ViewMore',
      defaultMessage: 'View More',
    },
  },
  statements: {
    months: {
      id: 'appointmentsCard.Statements.Months',
      defaultMessage: '{months} Month',
    },
    years: {
      id: 'appointmentsCard.Statements.Years',
      defaultMessage: '{years} Year',
    },
    followup: {
      id: 'appointmentsCard.Statements.Followup',
      defaultMessage: ' Follow-up',
    },
    today: {
      id: 'appointmentsCard.Statements.Today',
      defaultMessage: '(today)',
    },
    tomorrow: {
      id: 'appointmentsCard.Statements.Tomorrow',
      defaultMessage: '(tomorrow)',
    },
    daysAhead: {
      id: 'appointmentsCard.Statements.DaysAhead',
      defaultMessage: '(in {days} days)',
    },
    recommended: {
      id: 'appointmentsCard.Statements.Recommended',
      defaultMessage: 'Recommended',
    },
    timezone: {
      id: 'appointmentsCard.Statements.Timezone',
      defaultMessage: 'Appointment time is shown in {facilityTimeZone} unless otherwise specified.',
    },
    noAppointments: {
      id: 'appointmentsCard.Statements.NoAppointments',
      defaultMessage: 'No appointments to display',
    },
    status: {
      id: 'appointmentsCard.Statements.Status',
      defaultMessage: 'Status',
    },
  },
  screenReader: {
    requestAppointment: {
      id: 'appointmentsCard.ScreenReader.RequestAppointment',
      defaultMessage: 'Request a New Appointment link clicking takes you to contact us page',
    },
    viewMore: {
      id: 'appointmentsCard.ScreenReader.ViewMore',
      defaultMessage: 'View More link clicking opens a {page} page',
    },
  },
};
